import { render, staticRenderFns } from "./ListaFacturas.vue?vue&type=template&id=81c8fa72&"
import script from "./ListaFacturas.vue?vue&type=script&lang=js&"
export * from "./ListaFacturas.vue?vue&type=script&lang=js&"
import style0 from "./ListaFacturas.vue?vue&type=style&index=0&id=81c8fa72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports